import { LayoutPublic } from 'components/layout';
import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSendResetPasswordLinkMutation } from 'store/services/segmentsApi';
import { usePageTitle } from 'utils';

export default function ResetPassword() {
  usePageTitle('Reset Password | Segments');

  const [
    sendResetPasswordLink,
    { isLoading },
  ] = useSendResetPasswordLinkMutation();
  const form = useRef(null);

  /** @param {*} event */
  async function handleOnSubmit(event) {
    event.preventDefault();
    const { email } = event.target;

    sendResetPasswordLink({ email: email.value });
  }

  return (
    <LayoutPublic>
      <main className="w-full max-w-screen-xl px-5 mx-auto">
        <div className="flex items-center mt-24">
          <img
            src="/assets/logo-segments.png"
            alt="logo"
            className="w-8 h-8 md:w-10 md:h-10"
          />
          <h2 className="ml-3 text-2xl font-normal leading-7 tracking-segments_logo text-segments-dark">
            Segments
          </h2>
        </div>
        <form
          ref={form}
          onSubmit={handleOnSubmit}
          className="items-center justify-center max-w-md mx-auto mt-14"
        >
          <div>
            <h3 className="text-2xl font-bold">Reset your password</h3>

            <label htmlFor="email" className="block text-sm font-bold mt-11">
              Email
            </label>
            <TextField
              // @ts-ignore
              name="email"
              type="email"
              placeholder="Required"
              required
            />
          </div>
          <div className="flex items-center justify-between w-full mt-10">
            <p className="font-normal leading-4 cursor-not-allowed text-segments-13px">
              or{' '}
              <Link className="text-segments-link" to="/register">
                sign up
              </Link>{' '}
              for a new account
            </p>
            <div>
              <ButtonCTA variant="main" type="submit" disabled={isLoading}>
                <p className="px-6 font-bold">
                  {isLoading ? <SpinnerSmall /> : 'Reset'}
                </p>
              </ButtonCTA>
            </div>
          </div>
        </form>
      </main>
    </LayoutPublic>
  );
}
